module.exports = "/images/cashImg.svg";